'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatHoursToMinutes = exports.formatMinutesToHours = exports.hoursToMinutes = exports.minutesToHours = exports.combinedDateAndTime = exports.formatTimeWithPeriod = exports.formatTime = exports.formatMinutes = exports.formatHours = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _pluralize = require('../pluralize');

var _round = require('../round');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatHours = exports.formatHours = function formatHours(hours) {
  return (0, _pluralize.pluralizeWithCount)(hours, 'hour');
};
var formatMinutes = exports.formatMinutes = function formatMinutes(minutes) {
  return (0, _pluralize.pluralizeWithCount)(minutes, 'minute');
};

var formatTime = exports.formatTime = function formatTime(hours) {
  var minutes = hours * 60;
  var isHourInteger = Number.isInteger(hours);

  var integerInHours = Math.floor(hours);
  var decimalInMinutes = Math.round(hours % 1 * 60);

  if (isHourInteger) {
    return formatHours(hours);
  } else if (minutes > 60) {
    return formatHours(integerInHours) + ' and ' + formatMinutes(decimalInMinutes);
  }

  return formatMinutes(minutes);
};

var formatTimeWithPeriod = exports.formatTimeWithPeriod = function formatTimeWithPeriod(time, period) {
  return time + ' ' + period;
};

var combinedDateAndTime = exports.combinedDateAndTime = function combinedDateAndTime(date, time) {
  return (0, _moment2.default)(date).hour(time.get('hour')).minute(time.get('minute')).format();
};

var minutesToHours = exports.minutesToHours = function minutesToHours(durationInMinutes) {
  return (0, _round.roundToTwoDecimalPlaces)(durationInMinutes / 60);
};

var hoursToMinutes = exports.hoursToMinutes = function hoursToMinutes(durationInHours) {
  return (0, _round.roundToZeroDecimalPlaces)(durationInHours * 60);
};

var formatMinutesToHours = exports.formatMinutesToHours = function formatMinutesToHours(durationInMinutes) {
  return formatHours(minutesToHours(durationInMinutes));
};

var formatHoursToMinutes = exports.formatHoursToMinutes = function formatHoursToMinutes(durationInHours) {
  return formatMinutes(hoursToMinutes(durationInHours));
};